import { AccordionTab } from './accordion-tab';

export default AccordionTab;
